<template>
  <div class="container-main-body">
    <!--按钮开始-->
    <div class="list-container">
      <div v-if="searchShow" class="search-container">
        <el-row>
          <el-col :span="6">
            <div class="search-form-label">入库单号：</div>
            <div class="search-form-controller">
              <el-input
                size="mini"
                placeholder="入库单号"
                clearable
                v-model="queryData.halfproduct_no"
              ></el-input>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="search-form-label">入库日期:</div>
            <div class="search-form-controller">
              <el-date-picker
                style="width: 42%"
                type="date"
                size="mini"
                placeholder="开始日期"
                v-model="queryData.startDate"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
              <span style="width: 2%">-</span>
              <el-date-picker
                style="width: 42%"
                type="date"
                size="mini"
                placeholder="结束日期"
                v-model="queryData.endDate"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" style="text-align: center;">
            <el-button
              type="warning"
              size="mini"
              icon="el-icon-search"
              plain
              @click="searchHandler"
              >开始搜索</el-button
            >
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-delete"
              plain
              @click="searchHandler('clear')"
              >清空</el-button
            >
            <el-button
              type="danger"
              size="mini"
              icon="el-icon-close"
              plain
              @click="showSearchHandler()"
              >关闭搜索</el-button
            >
          </el-col>
        </el-row>
      </div>
      <div class="list-btns-container">
        <el-button-group>
          <el-button
            v-for="btn in $store.state.currentLBtnList"
            :key="btn.id"
            :type="btn.button_type"
            size="mini"
            :icon="btn.button_icon"
            @click="handlerButtonDispatch(btn.fn)"
            >{{ btn.button_name }}</el-button
          >
        </el-button-group>
      </div>
      <!--按钮结束-->
      <!--列表数据 开始-->
      <div class="el-table-container">
        <el-table
          :data="ds"
          size="mini"
          stripe
          border
          height="100%"
          style="width: 100% border:1px solid #d1d1d1"
          header-row-class-name="list-header-row"
          row-class-name="list-row"
        >
          <el-table-column
            label="入库单号"
            prop="halfproduct_no"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            label="入库日期"
            prop="date"
            width="100"
            align="center"
          ></el-table-column>
          <el-table-column
            label="台数"
            prop="table_number"
            width="100"
            align="center"
          ></el-table-column>
          <el-table-column
            label="页码"
            prop="page"
            width="100"
            align="center"
          ></el-table-column>
          <el-table-column
            label="送货数量"
            prop="delivery_number"
            width="100"
            align="center"
          ></el-table-column>
          <el-table-column
            label="数量"
            prop="number"
            width="100"
            align="center"
          ></el-table-column>
          <el-table-column
            label="异常原因"
            prop="exception_result"
            align="center"
          ></el-table-column>
          <el-table-column label="操作" width="90" align="center">
            <template slot-scope="scope">
              <el-button
                v-if="role_name === '超级权限' || role_name === '软件管理'"
                type="danger"
                size="mini"
                icon="el-icon-minus"
                circle
                @click.stop.prevent="handlerDelDetails(scope.row)"
              ></el-button>
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-view"
                circle
                plain
                @click.stop.prevent="viewHandler(scope.row)"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-container">
        <el-pagination
          background
          :current-page="queryData.pn"
          :page-size="queryData.pageSize"
          :total="queryData.totalCount"
          :page-sizes="[10, 15, 20, 25, 30, 50, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChange"
          @current-change="pageChange"
        ></el-pagination>
      </div>
    </div>
    <!--列表数据 结束-->
    <ezz-dialog-product-part
      ref="partDialog"
      :parent="this"
    ></ezz-dialog-product-part>
  </div>
</template>

<script>
import EzzDialogProductPart from "@/views/modules/exception/halfinstoreexception/DialogPart.vue";
export default {
  data: function() {
    return {
      ds: [],
      // 分页
      queryData: {
        halfproduct_no: "",
        startDate: "",
        endDate: "",
        pn: 1, // 页码
        pageSize: 20, // 每页条数
        totalCount: 0 // 数据总条数
      },
      searchShow: false,
      operator_id: sessionStorage.getItem("operator_id"),
      outsource_company_id: sessionStorage.getItem("outsource_company_id"),
      role_name: sessionStorage.getItem("role_name")
    };
  },
  created: function() {},
  mounted: function() {
    this.loadData();
  },
  methods: {
    // 按钮 点击 调度方法
    handlerButtonDispatch: function(fn, args) {
      var _this = this;
      if (typeof _this[fn] === "function") {
        _this[fn].apply(_this, args);
      } else {
        console.log("warning: the method is not exist");
      }
    },
    // 加载数据
    loadData: function() {
      let _this = this;
      _this.post(
        _this.$apis.getHalfInstoreExceptionList,
        this.queryData,
        function(res) {
          let _json = res.data;
          if (_json.status && _json.status === "logout") {
            _this.logout();
          } else {
            if (_this.outsource_company_id === "0") {
              _this.ds = _json.datalist;
              _this.queryData.totalCount = _json.totalCount;
            } else {
              _this.ds = _json.datalist.filter(function(item) {
                return item.company_id === _this.outsource_company_id;
              });
              _this.queryData.totalCount = _this.ds.length;
            }
          }
        }
      );
    },
    // 浏览
    viewHandler: function(_row) {
      let formId = _row.halfproduct_id;
      this.$refs.partDialog.viewHandler(formId);
    },
    searchHandler: function(_type) {
      this.queryData.pn = 1;
      if (_type === "clear") {
        this.queryData.halfproduct_no = "";
        this.queryData.startDate = "";
        this.queryData.endDate = "";
      }
      this.loadData();
    },
    showSearchHandler: function() {
      this.searchShow = !this.searchShow;
    },
    // 刷新事件
    refreshHandler: function() {
      this.loadData();
    },
    // 页码改变
    pageSizeChange: function(pageSize) {
      this.queryData.pn = 1;
      this.queryData.pageSize = pageSize;
      this.loadData();
    },
    pageChange: function(pn) {
      this.queryData.pn = pn;
      this.loadData();
    },
    // 设置去除异常
    handlerDelDetails: function(_row) {
      let _this = this;
      _this
        .$confirm("确定设置为非异常?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          _this.post(
            _this.$apis.delHalfExceptionHandler,
            { ExceptionId: _row.id },
            function(res) {
              let _json = res.data;
              if (_json.status && _json.status === "logout") {
                _this.logout();
              } else {
                if (_json.status === "ok") {
                  _this.$message({
                    message: "设置成功",
                    type: "success"
                  });
                  _this.loadData();
                }
              }
            }
          );
        })
        .catch(() => {
          _this.$message({
            type: "info",
            message: "已取消设置"
          });
        });
    }
  },
  components: {
    EzzDialogProductPart
  }
};
</script>
